import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useRef, useState } from "react";
import { Form, Stack } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import AlignBox from "../../../../components/AlignBox/AlignBox";
import DashboardCard from "../../../../components/CustomCard/DashboardCard/DashboardCard";
import PfIconPolygon from "../../../../components/CustomIcons/PfIconPolygon/PfIconPolygon";
import PosteTypeIcon from "../../../../components/CustomIcons/PosteTypeIcon/PosteTypeIcon";
import DashboardModal from "../../../../components/CustomModal/DashboardModal/DashboardModal";
import QRCodePDF from "../../../../components/PDF/QRCodePDF/QRCodePDF";
import QRCodeLogo from "../../../../components/QRCodeLogo/QRCodeLogo";
import BasicInput from "../../../../components/inputs/BasicInput/BasicInput";
import FetchSelect from "../../../../components/inputs/FetchSelect/FetchSelect";
import config from "../../../../config/config";
import useFetch from "../../../../services/useFetch";
import TimelinePoste from "./TimelinePoste/TimelinePoste";

const schema = yup
  .object({
    nom: yup.string().required("Nom du poste obligatoire."),

    type: yup.number().required("Type obligatoire").integer(),
  })
  .required();

const ModalPoste = ({ show, handleClose, idPoste }) => {
  const [idEmplacement, setIdEmplacement] = useState(null);
  const apiUrlPoste = config.apiUrl + "/poste-form/" + idPoste;
  const apiUrlPosteType = config.apiUrl + "/poste-types";
  const isComponentMounted = useRef(true);
  const [localDataPoste, setLocalDataPoste] = useState(null);

  const {
    register,
    reset,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    loading: loadingPoste,
    data: dataPoste,
    triggerFetch: triggerFetchPoste,
  } = useFetch(apiUrlPoste, isComponentMounted, []);

  const menu = [
    {
      text: "Activité",
      component: <TimelinePoste idEmplacement={idEmplacement}></TimelinePoste>,
    },
  ];

  useEffect(() => {
    if (show) {
      triggerFetchPoste(apiUrlPoste, {
        method: "GET",
      });
    }
  }, [show]);

  useEffect(() => {
    if (dataPoste) {
      setLocalDataPoste(dataPoste);
      setIdEmplacement(dataPoste.emplacement.id.value);
      setValue("nom", dataPoste.nom.value);
      setValue("type", dataPoste.type.id.value);
    }
  }, [dataPoste]);

  return (
    <>
      {localDataPoste && (
        <DashboardModal
          dataMenu={menu}
          fullscreen={true}
          show={show}
          handleClose={handleClose}
          iconTitle={
            <PosteTypeIcon
              size={1.7}
              idPosteType={localDataPoste.type.id.value}
            />
          }
          title={localDataPoste.nom.value}
          subTitle={localDataPoste.type.libelle.value}
          details={
            <>
              <DashboardCard>
                <Stack direction="horizontal" gap={3}>
                  <div>
                    <DashboardCard theme="light" className="d-inline-block">
                      <QRCodeLogo
                        size={100}
                        viewBox={`0 0 100 100`}
                        value={localDataPoste.qrcode}
                      >
                        <PfIconPolygon size={50}></PfIconPolygon>
                      </QRCodeLogo>
                    </DashboardCard>
                  </div>
                  <div className="w-50">
                    <div className="Montserrat-SemiBold h5 mb-0">
                      Identification
                    </div>
                    <div className="Montserrat-Regular h6 text-uppercase">
                      QR Code
                    </div>
                    <div className="w-100">{localDataPoste.qrcode}</div>
                  </div>
                </Stack>
                <Stack direction="horizontal" gap={3}>
                  <div className="ms-auto">
                    <QRCodePDF
                      qrCodeData={localDataPoste.qrcode}
                      title={localDataPoste.nom.value}
                      text="Imprimer"
                      variant="hybride"
                      buttonSize="sm"
                    ></QRCodePDF>
                  </div>
                </Stack>
              </DashboardCard>
              <BasicInput
                labelText="Identifiant"
                controlId="id"
                control={control}
                name="id"
                placeholder={localDataPoste.id.value}
                disabled={!localDataPoste.id.field}
              />
              <BasicInput
                labelText="Nom du stockage"
                controlId="nom"
                control={control}
                name="nom"
                placeholder="Entrez le nom de l'utilisateur"
                errorMessage={errors.nom?.message}
                registerFunction={register("nom")}
              />
              <FetchSelect
                urlOptions={apiUrlPosteType}
                labelText="Type de stockage"
                onSelectChange={(selectedValue) =>
                  setValue("type", selectedValue)
                }
                placeholder="Selectionnez le type"
                defaultIdValue={localDataPoste.type.id.value}
                control={control}
                name="type"
                option={{
                  value: "id",
                  text: (row) => (
                    <>
                      <AlignBox>
                        <PosteTypeIcon
                          idPosteType={row.id}
                          size={2}
                          className="me-3"
                        />
                        {row.libelle}
                      </AlignBox>
                    </>
                  ),
                }}
                setValue={setValue}
                errorMessage={errors.type?.message}
                registerFunction={register("type")}
              />
              <BasicInput
                labelText="Date de création"
                controlId="creation"
                control={control}
                name="creation"
                placeholder={localDataPoste.creation.value}
                disabled={!localDataPoste.creation.field}
              />
            </>
          }
          validationButtonText={"Enregistrer le poste"}
          onExited={() => {
            reset({}, { errors: true });
            setLocalDataPoste(null);
          }}
        >
          <Form noValidate></Form>
        </DashboardModal>
      )}
    </>
  );
};

export default ModalPoste;
